/* eslint-disable arrow-parens */
import classesApi from '@/api/classes';
import studentsApi from '@/api/students';

// initial state
const state = {
  classes: [],
  classesError: null,
  selectedClass: null,
  addClassModalOpen: false,
  students: [],
  otherStudents: [],
  classesOnPage: [],
  classesPaging: {
    page: 1,
    pageSize: 20,
    totalDataCount: 0,
  },
};

// getters
const getters = {
  classes: (currentState) => currentState.classes,
  classesError: (currentState) => currentState.classesError,
  pagedClasses: (currentState) => currentState.classesOnPage,
  classStudents: (currentState) => currentState.students,
  classOtherStudents: (currentState) => currentState.otherStudents,
  selectedClass: (currentState) => currentState.selectedClass,
  addClassModalOpen: (currentState) => currentState.addClassModalOpen,
  classesHasNextPage: (currentState) =>
    currentState.classesPaging.page * currentState.classesPaging.pageSize <
    currentState.classesPaging.totalDataCount,
  classesHasPreviousPage: (currentState) => currentState.classesPaging.page > 1,
  classesTotalPages: (currentState) =>
    Math.ceil(
      currentState.classesPaging.totalDataCount /
        currentState.classesPaging.pageSize,
    ),
};

// actions
const actions = {
  showAddClassModal({ commit }) {
    commit('setAddClassModalOpen', true);
  },
  hideAddClassModal({ commit }) {
    commit('setAddClassModalOpen', false);
  },
  getClassStudents({ dispatch, commit }, group) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      classesApi.getStudents(group).then(
        (response) => {
          commit('setClassStudents', { students: response.data });
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  getClassStudentsById({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      classesApi.getStudentsById(id).then(
        (response) => {
          commit('setClassStudents', { students: response.data });
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  getClassOtherStudents({ dispatch, commit }, group) {
    dispatch('showLoader');
    classesApi.getOtherStudents(group).then((response) => {
      commit('setClassOtherStudents', { students: response.data });
      dispatch('hideLoader');
    });
  },
  createClassStudents({ dispatch, state: currentState }, students) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      studentsApi.createStudents(students).then(
        (response) => {
          dispatch('getClassStudents', currentState.selectedClass);
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  getClasses({ dispatch, commit }) {
    dispatch('showLoader');
    classesApi
      .getClasses()
      .then((response) => {
        commit('setClassesError', null);
        commit('setClasses', { classes: response.data });
        dispatch('hideLoader');
      })
      .catch((error) => {
        commit(
          'setClassesError',
          `An error occurred while trying to retrieve the list of classes (${error.response.statusText})`,
        );
        commit('setClasses', { classes: [] });
        dispatch('hideLoader');
      });
  },
  getClassesBySchoolCode({ dispatch, commit }, schoolCode) {
    dispatch('showLoader');
    classesApi
      .getClassesBySchoolCode(schoolCode)
      .then((response) => {
        commit('setClassesError', null);
        commit('setClasses', { classes: response.data });
        dispatch('hideLoader');
      })
      .catch((error) => {
        commit(
          'setClassesError',
          `An error occurred while trying to retrieve the list of classes (${error.response.statusText})`,
        );
        commit('setClasses', { classes: [] });
        dispatch('hideLoader');
      });
  },
  getPagedClasses({ dispatch, commit }, paging) {
    dispatch('showLoader');
    classesApi.getPagedClasses(paging).then((response) => {
      commit('setPagedClasses', {
        classes: response.data.data,
        paging: {
          page: response.data.page,
          pageSize: response.data.pageSize,
          totalDataCount: response.data.totalDataCount,
        },
      });
      dispatch('hideLoader');
    });
  },
  selectClass({ commit }, group) {
    commit('selectClass', { group });
  },
  createClass({ dispatch }, group) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      classesApi.createClass(group).then(
        (response) => {
          dispatch('getClasses');
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  removeClass({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      classesApi.removeClass(id).then(
        (response) => {
          dispatch('getClasses');
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  setClassStudents({ dispatch }, students) {
    dispatch('setClassStudents', students);
  },
};

// mutations
const mutations = {
  setClasses(currentState, { classes }) {
    currentState.classes = classes;
  },
  setClassStudents(currentState, { students }) {
    currentState.students = students;
  },
  setClassOtherStudents(currentState, { students }) {
    currentState.otherStudents = students;
  },
  selectClass(currentState, { group }) {
    currentState.selectedClass = group;
  },
  setPagedClasses(currentState, { classes, paging }) {
    currentState.classesOnPage = classes;
    currentState.classesPaging = paging;
  },
  setAddClassModalOpen(currentState, isOpen) {
    currentState.addClassModalOpen = isOpen;
  },
  setClassesError(currentState, error) {
    currentState.classesError = error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/classes.js